// extracted by mini-css-extract-plugin
export default {"button":"button_style_button__n6f8L","buttonGold":"button_style_buttonGold__eqA-U","buttonWhite":"button_style_buttonWhite__Yybqr","buttonBlue":"button_style_buttonBlue__SrNyB"};